import React, { useState } from "react";
import {
    Flex,
    Text,
    useColorModeValue,
    Input,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import GradientButton from "components/Buttons/GradientButton";
import { useCustomNotification } from "components/Toasts/OpenNotification";

const ChangePasswordCard = ({ isLoading, onPasswordChange }) => {
    const textColor = useColorModeValue("gray.700", "white");
    const notify = useCustomNotification();

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChangePassword = async () => {
        if (!currentPassword || !newPassword) {
            notify({
                type: "warning",
                message: "Missing Fields",
                description: "Please enter both current and new password.",
            });
            return;
        }

        try {
            setLoading(true);
            notify({
                type: "loading",
                description: "Updating password...",
                duration: 3,
            });

            const result = await onPasswordChange(currentPassword, newPassword);
            if (result.success) {
                notify({
                    type: "success",
                    message: "Password Changed",
                    description: "Your password has been updated successfully.",
                });
                setCurrentPassword("");
                setNewPassword("");
            } else {
                notify({
                    type: "error",
                    message: "Password Update Failed",
                    description: result.error || "Something went wrong. Please try again.",
                });
            }
        } catch (error) {
            notify({
                type: "error",
                message: "Password Update Failed",
                description: "Something went wrong. Please try again.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card p="16px" >
            <CardHeader p="12px 5px" mb="12px">
                <Text fontSize="lg" color={textColor} fontWeight="bold">
                    Change Password
                </Text>
            </CardHeader>
            <CardBody px="5px">
                <Flex direction="column" gap="16px" w='100%'>
                    <Input
                        type="password"
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        disabled={loading}
                        width="100%"
                    />
                    <Input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        disabled={loading}
                        width="100%"
                    />
                    <GradientButton
                        width="100%"
                        height="40px"
                        loading={loading}
                        onClick={handleChangePassword}
                    >
                        Change Password
                    </GradientButton>
                </Flex>
            </CardBody>
        </Card>
    );
};


export default ChangePasswordCard;
